import { render, staticRenderFns } from "./AdvancedSettingsPage.vue?vue&type=template&id=9ad06af2&lang=pug&"
import script from "./AdvancedSettingsPage.vue?vue&type=script&lang=js&"
export * from "./AdvancedSettingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports